import { ReactNode } from 'react';

interface SidebarLayoutProps {
  main: ReactNode;
  sidebar: ReactNode;
  leftSidebar?: ReactNode;
}

/**
 * Layout component with main content, optional left sidebar, and right sidebar
 * Both sidebars take full height of the page
 */
export const SidebarLayout = ({ main, sidebar, leftSidebar }: SidebarLayoutProps) => {
  return (
    <div className="grid grid-cols-12 gap-6 w-full min-h-[calc(100vh-theme(spacing.16))]">
      {/* Left Sidebar - if provided */}
      {leftSidebar && (
        <div className="col-span-3 sticky top-6">
          <div className="h-full">
            {leftSidebar}
          </div>
        </div>
      )}
      
      {/* Main Content Area - fills the space between sidebars */}
      <div className={`${leftSidebar ? 'col-span-7' : 'col-span-10'}`}>
        {main}
      </div>
      
      {/* Right Sidebar - Full Height, always anchored to the right */}
      <div className="col-span-2 sticky top-6">
        <div className="h-full">
          {sidebar}
        </div>
      </div>
    </div>
  );
};